import {Component, Input, OnInit} from '@angular/core';
import Swal, {default as swal} from 'sweetalert2';
import {ApprovalModel} from '../../shared/dto/approval.model';
import {FormControl, FormGroup} from '@angular/forms';
import {ChecklistModel} from '../../shared/dto/checklist.model';
import {Router} from '@angular/router';
import {BlacklistService} from '../../shared/service/blacklist.service';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ChecklistService} from '../../service/checklist.service';
import {ChecklistEnum} from '../../shared/enums/checklist.enum';
import {ReversedSuspendService} from '../../shared/service/reversed-suspend.service';
import {ActionMode} from '../../shared/enums/action-mode.enum';
import {TokenStorageService} from '../../shared/service/token-storage.service';
import {UserRoleEnum} from '../../shared/enums/user-role.enum';
import {WorkflowEnum} from '../../shared/enums/workflow.enum';

@Component({
  selector: 'app-blacklist-approve-checklist',
  templateUrl: './blacklist-approve-checklist.component.html',
  styleUrls: ['./blacklist-approve-checklist.component.scss']
})
export class BlacklistApproveChecklistComponent implements OnInit {

  remarkForm: FormGroup;
  @Input() fromParent;
  approvalModel: ApprovalModel = new ApprovalModel();
  isError: boolean = false;
  isSucess: boolean = false;
  public checklist: ChecklistModel[];
  public isValidChecklist = true;
  public selectedIdArr: number[]=[];
  public checklistId: number[]=[];
  public checklistType: string;
  public applicentType: string;

  constructor(private blacklistService: BlacklistService, private router: Router,private activeModal: NgbActiveModal,
              private checklistService: ChecklistService, private tokenStorageService: TokenStorageService) { }

  ngOnInit() {
    this.approvalModel = this.fromParent.model;
    this.applicentType = this.fromParent.appType;

    this.remarkForm = new FormGroup({
      remark: new FormControl(null),
    });

    this.getChecklist();
  }

  submitRequest() {
    this.approvalModel.remark = this.remarkForm.value.remark;
    this.approvalModel.selectedIdArr = this.selectedIdArr;

    if(this.approvalModel.process === ActionMode.REVERSE_SUSPEND){
      Swal.fire({
        title: 'Are you sure?',
        text: 'You want to approve the request?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes!',
        cancelButtonText: 'No'
      }).then((result) => {
        if (result.value) {
          // alert(this.approvalModel.type,"this.approvalModel");
          this.blacklistService.approvalProcess(this.approvalModel).subscribe(
            (success: string) => {

              swal.fire("Success", "Details submitted successfully", "success");
              this.activeModal.close({ status: 'Saved', data: "" });

              if(this.router.url.includes('/dashboard/reversed-suspend-data/')) {
                this.router.navigate(['/dashboard/reversed-suspend',this.applicentType]);

              }else if(this.router.url.includes('/dashboard/reversed-suspend-authorization/')) {
                this.router.navigate(['/dashboard/reversed-suspend-authorizations/',this.approvalModel.type]);

              }else if(this.router.url.includes('/dashboard/reversed-suspend-verification/')) {
               this.router.navigate(['/dashboard/reversed-suspend-verifications/',this.applicentType]);

          }
              this.blacklistService.close();
            },
            (error) => {
              swal.fire("Sorry!", "Error When Updating the Request...!", "error");
            },
          );
        } else {
        }
      });
    }else {
      Swal.fire({
        title: 'Are you sure?',
        text: 'You want to approve the request?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes!',
        cancelButtonText: 'No'
      }).then((result) => {
        if (result.value) {
          // alert("asdddddddddddddddddddd11"+this.applicentType);

          this.blacklistService.approvalProcess(this.approvalModel).subscribe(
            (success: string) => {
              swal.fire("Success", "Details submitted successfully", "success");
              this.activeModal.close({ status: 'Saved', data: "" });

              if(this.router.url.includes('/dashboard/blacklist-data/')){
                this.router.navigate(['/dashboard/blacklist/',this.applicentType] );

              }else if(this.router.url.includes('/dashboard/reversed-blacklist-data/')){
                this.router.navigate(['/dashboard/reversed-blacklist',this.applicentType] );

              }else if(this.router.url.includes('/dashboard/blacklist-return-data/')) {
                this.router.navigate(['/dashboard/blacklist-return-data',this.applicentType]);

              }else if(this.router.url.includes('/dashboard/reversed-blacklist-return-data/')){
                this.router.navigate(['/dashboard/reversed-blacklist-return-data',this.applicentType]);

              }else if(this.router.url.includes('/dashboard/suspend-return-data/')){
                this.router.navigate(['/dashboard/suspend-return-data',this.applicentType]);

              }else if(this.router.url.includes('/dashboard/blacklist-verification/')) {
                this.router.navigate(['/dashboard/blacklist-verifications/', this.applicentType]);

              }else if(this.router.url.includes('/dashboard/suspend-verification/')) {
                this.router.navigate(['/dashboard/suspend-verifications',this.applicentType]);

              }else if(this.router.url.includes('/dashboard/suspend-authorization/')) {
                this.router.navigate(['/dashboard/suspend-authorizations',this.applicentType]);

              }else if(this.router.url.includes('/dashboard/blacklist-authorization/')) {
                this.router.navigate(['/dashboard/blacklist-authorization',this.applicentType]);

              }else if(this.router.url.includes('/dashboard/reversed-blacklist-verification/')){
                this.router.navigate(['/dashboard/reversed-blacklist-verifications',this.applicentType]);

              }else if(this.router.url.includes('/dashboard/reversed-blacklist-authorization/')){
                this.router.navigate(['/dashboard/reversed-blacklist-authorizations',this.approvalModel.type]);

              }else if(this.router.url.includes('/dashboard/blacklist-return/')){
                this.router.navigate(['/dashboard/return-request-data',this.applicentType]);

              }else if(this.router.url.includes('/dashboard/reversed-blacklist-return/')) {
                this.router.navigate(['/dashboard/reversed-return-request-data',this.applicentType]);

              }else if(this.router.url.includes('/dashboard/reversed-suspend-blacklist-verification/')) {
                this.router.navigate(['/dashboard/reversed-suspend-blacklist-verification',this.applicentType]);

              }else if(this.router.url.includes('/dashboard/reversed-suspend-blacklist-authorization/')) {
                this.router.navigate(['/dashboard/reversed-suspend-blacklist-authorization',this.applicentType]);

              }else if(this.router.url.includes('/dashboard/suspend-blacklist-verification/')) {
                this.router.navigate(['/dashboard/suspend-blacklist-verification',this.applicentType]);

              }else if(this.router.url.includes('/dashboard/suspend-blacklist-authorization/')) {
                this.router.navigate(['/dashboard/suspend-blacklist-authorization',this.applicentType]);
              }

              this.blacklistService.close();
            },
            (error) => {
              swal.fire("Sorry!", "Error When Updating the Request...!", "error");
            },
          );
        } else {
        }
      });
    }
  }

  getChecklist() {
    if((this.tokenStorageService.getUserObjectToken().userroleCode == UserRoleEnum.EXM) && (this.approvalModel.stage == WorkflowEnum.BLACKLIST)) {
      this.checklistType = ChecklistEnum.BLK_CHECK_EXM;
    }

    if((this.tokenStorageService.getUserObjectToken().userroleCode == UserRoleEnum.DG) && (this.approvalModel.stage == WorkflowEnum.BLACKLIST)) {
      this.checklistType = ChecklistEnum.BLK_CHECK_DG;
    }

    if((this.tokenStorageService.getUserObjectToken().userroleCode == UserRoleEnum.EXM) && (this.approvalModel.stage == WorkflowEnum.SUSPEND)) {
      this.checklistType = ChecklistEnum.SUS_CHECK_EXM;
    }

    if((this.tokenStorageService.getUserObjectToken().userroleCode == UserRoleEnum.DG) && (this.approvalModel.stage == WorkflowEnum.SUSPEND)) {
      this.checklistType = ChecklistEnum.SUS_CHECK_DG;
    }

    if((this.tokenStorageService.getUserObjectToken().userroleCode == UserRoleEnum.EXM) && (this.approvalModel.stage == WorkflowEnum.SUSPEND_REVERSED_RETURN)) {
      this.checklistType = ChecklistEnum.SUS_REV_RET_CHECK_EXM;
    }

    if((this.tokenStorageService.getUserObjectToken().userroleCode == UserRoleEnum.SHO) && (this.approvalModel.stage == WorkflowEnum.SUSPEND_REVERSED_RETURN)) {
      this.checklistType = ChecklistEnum.SUS_REV_RET_CHECK_SHO;
    }

    if((this.tokenStorageService.getUserObjectToken().userroleCode == UserRoleEnum.DG) && (this.approvalModel.stage == WorkflowEnum.SUSPEND_REVERSED_RETURN)) {
      this.checklistType = ChecklistEnum.SUS_REV_RET_CHECK_DG;
    }

    if((this.tokenStorageService.getUserObjectToken().userroleCode == UserRoleEnum.EXM) && (this.approvalModel.stage == WorkflowEnum.BLACKLIST_REVERSED_RETURN)) {
      this.checklistType = ChecklistEnum.BLK_REV_RET_CHECK_EXM;
    }

    if((this.tokenStorageService.getUserObjectToken().userroleCode == UserRoleEnum.DG) && (this.approvalModel.stage == WorkflowEnum.BLACKLIST_REVERSED_RETURN)) {
      this.checklistType = ChecklistEnum.BLK_REV_RET_CHECK_DG;
    }

    if((this.tokenStorageService.getUserObjectToken().userroleCode == UserRoleEnum.EXM) && (this.approvalModel.stage == WorkflowEnum.SUSPEND_BLACKLIST_REVERSED)) {
      this.checklistType = ChecklistEnum.SUS_BLK_REV_CHECK_EXM;
    }

    if((this.tokenStorageService.getUserObjectToken().userroleCode == UserRoleEnum.DG) && (this.approvalModel.stage == WorkflowEnum.SUSPEND_BLACKLIST_REVERSED)) {
      this.checklistType = ChecklistEnum.SUS_BLK_REV_CHECK_DG;
    }

    if((this.tokenStorageService.getUserObjectToken().userroleCode == UserRoleEnum.EXM) && (this.approvalModel.stage == WorkflowEnum.BLACKLIST_REVERSED)) {
      this.checklistType = ChecklistEnum.BLK_REV_CHECK_EXM;
    }

    if((this.tokenStorageService.getUserObjectToken().userroleCode == UserRoleEnum.DG) && (this.approvalModel.stage == WorkflowEnum.BLACKLIST_REVERSED)) {
      this.checklistType = ChecklistEnum.BLK_REV_CHECK_DG;
    }

    if((this.tokenStorageService.getUserObjectToken().userroleCode == UserRoleEnum.EXM) && (this.approvalModel.stage == WorkflowEnum.SUSPEND_RETURN)) {
      this.checklistType = ChecklistEnum.SUS_RET_CHECK_EXM;
    }

    if((this.tokenStorageService.getUserObjectToken().userroleCode == UserRoleEnum.DG) && (this.approvalModel.stage == WorkflowEnum.SUSPEND_RETURN)) {
      this.checklistType = ChecklistEnum.SUS_RET_CHECK_DG;
    }

    if((this.tokenStorageService.getUserObjectToken().userroleCode == UserRoleEnum.EXM) && (this.approvalModel.stage == WorkflowEnum.BLACKLIST_RETURN)) {
      this.checklistType = ChecklistEnum.BLK_RET_CHECK_EXM;
    }

    if((this.tokenStorageService.getUserObjectToken().userroleCode == UserRoleEnum.DG) && (this.approvalModel.stage == WorkflowEnum.BLACKLIST_RETURN)) {
      this.checklistType = ChecklistEnum.BLK_RET_CHECK_DG;
    }

    if((this.tokenStorageService.getUserObjectToken().userroleCode == UserRoleEnum.EXM) && (this.approvalModel.stage == WorkflowEnum.SUSPEND_REVERSED)) {
      this.checklistType = ChecklistEnum.SUS_REV_CHECK_EXM;
    }

    if((this.tokenStorageService.getUserObjectToken().userroleCode == UserRoleEnum.DG) && (this.approvalModel.stage == WorkflowEnum.SUSPEND_REVERSED)) {
      this.checklistType = ChecklistEnum.SUS_REV_CHECK_DG;
    }

    if((this.tokenStorageService.getUserObjectToken().userroleCode == UserRoleEnum.SHO) && (this.approvalModel.stage == WorkflowEnum.SUSPEND_REVERSED)) {
      this.checklistType = ChecklistEnum.SUS_REV_CHECK_SHO;
    }

    if((this.tokenStorageService.getUserObjectToken().userroleCode == UserRoleEnum.EXM) && (this.approvalModel.stage == WorkflowEnum.SUSPEND_BLACKLIST)) {
      this.checklistType = ChecklistEnum.SUS_BLK_CHECK_EXM;
    }

    if((this.tokenStorageService.getUserObjectToken().userroleCode == UserRoleEnum.DG) && (this.approvalModel.stage == WorkflowEnum.SUSPEND_BLACKLIST)) {
      this.checklistType = ChecklistEnum.SUS_BLK_CHECK_DG;
    }

    if((this.tokenStorageService.getUserObjectToken().userroleCode == UserRoleEnum.EXM) && (this.approvalModel.stage == WorkflowEnum.SUSPEND_BLACKLIST_RETURN)) {
      this.checklistType = ChecklistEnum.SUS_BLK_RET_CHECK_EXM;
    }


    this.checklistService.getChecklistByType(this.checklistType).subscribe(
      (result: any ) => {
        this.checklist = result;
        if(this.checklist.length > 0) {
          this.checklist.forEach(item => {
            this.checklistId.push(item.id);
          });
          this.isValidChecklist = true;
        }else{
          this.isValidChecklist = false;
        }
      }
    );
  }

  isAllSelected(id,event) {
    if(event.checked)
      this.selectedIdArr.push(id);
    else {
      var index = this.selectedIdArr.indexOf(id);
      if(index > -1)
        this.selectedIdArr.splice(index,1);
    }

    if(JSON.stringify(this.checklistId)==JSON.stringify(this.selectedIdArr)) {
      this.isValidChecklist = false;
    }else {
      this.isValidChecklist = true;
    }


  }

}
